import { createSelector, createSelectorCreator, defaultMemoize } from 'reselect';
import { getDeviceInteraction } from './getDeviceInteraction';

// Get allPlays from the gumbo
const getAllPlaysHelper = (state) => {
    const {
        gumbo: {
            gamePk,
            liveData: {
                plays: {
                    allPlays = []
                } = {},
            } = {}
        } = {}
    } = state || {};

    return {
        allPlays,
        gamePk
    };
};

// Custom selector factory that won't invalidate unless allPlays has changed size, or the gamePk changes
// Just to be used for meta data about the play itself.
export const createAllPlaysSelector = createSelectorCreator(defaultMemoize, ( {gamePk, allPlays = []}, {gamePk: previousGamePk, allPlays: previousAllPlays = [] }) => {
    return allPlays.length === previousAllPlays.length && gamePk === previousGamePk;
});

export const getAllPlays = createAllPlaysSelector(
    [ getAllPlaysHelper ],
    ( { allPlays }) => allPlays
);
